import { resendStatement } from '../services/dashboardService'

import types from './types'

const { SET_RESENT_STATEMENT } = types

function fetchReasonList(fastId) {
  return dispatch =>
    resendStatement(fastId).then(response => {
      dispatch({
        type: SET_RESENT_STATEMENT,
        state: response
      })
      return response
    })
}

export default fetchReasonList



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchResendStatement.js